
export class HSLColor {
    H!: number;
    S!: number;
    L!: number;

    public toString = (): string => {

        return `hsl(${this.H}, ${this.S}%, ${this.L}%)`;
    }
}
